'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const alignContent = {
	start: "sOkqv",
	center: "AGb-Y",
	"space-between": "qKpIz",
	"space-around": "GYJqd"
};
const alignContentEnums = [
	"start",
	"center",
	"space-between",
	"space-around"
];
const alignItems = {
	stretch: "eUlZ-",
	center: "Hfl3q",
	start: "y58gg",
	end: "j5MMP",
	"flex-end": "BBrYa"
};
const alignItemsEnums = [
	"stretch",
	"center",
	"start",
	"end",
	"flex-end"
];
const alignSelf = {
	stretch: "JwnmW",
	center: "EEj6H",
	start: "z-inf",
	end: "mD6hV",
	"flex-end": "_42-SH"
};
const alignSelfEnums = [
	"stretch",
	"center",
	"start",
	"end",
	"flex-end"
];
const borderBottomLeftRadius = {
	xs: "-sYYG",
	sm: "NaGPd",
	md: "_6BWzN",
	lg: "TznYK",
	xl: "bPhOy",
	clear: "Wo-LT"
};
const borderBottomRightRadius = {
	xs: "_4PDAI",
	sm: "ZwboH",
	md: "SFLjH",
	lg: "L-pTp",
	xl: "fFlbU",
	clear: "OhvGX"
};
const borderBottomStyle = {
	none: "heu8b",
	hidden: "XzbyC",
	dotted: "zH4n4",
	dashed: "zxv2R",
	solid: "Zvp6i",
	double: "OPzVb",
	groove: "V-say",
	ridge: "gDSI6",
	inset: "Cfvzi",
	outset: "nnUxJ"
};
const borderBottomWidth = {
	thin: "GgaaC",
	thick: "GINvg",
	clear: "_8WcGz"
};
const borderLeftStyle = {
	none: "BndUy",
	hidden: "kzLJC",
	dotted: "a9icJ",
	dashed: "jRi30",
	solid: "_5B0cM",
	double: "wyEuE",
	groove: "oYnFr",
	ridge: "_65tjD",
	inset: "tPDYs",
	outset: "CI6ef"
};
const borderLeftWidth = {
	thin: "cJ4h4",
	thick: "DWpRH",
	clear: "dBDaL"
};
const borderRightStyle = {
	none: "N5APu",
	hidden: "JMmDv",
	dotted: "_55iQ4",
	dashed: "BOYAP",
	solid: "GBAcD",
	double: "JTANz",
	groove: "_6WfZ2",
	ridge: "VCRPv",
	inset: "vekTI",
	outset: "j9t1F"
};
const borderRightWidth = {
	thin: "gnYkn",
	thick: "LYYlb",
	clear: "ISoUd"
};
const borderStyle = {
	none: "QTUJU",
	hidden: "YlTrU",
	dotted: "uuYbc",
	dashed: "_85Oqp",
	solid: "yBip6",
	double: "vXtiH",
	groove: "WDuaD",
	ridge: "F2NvP",
	inset: "XzHx4",
	outset: "QV0ci"
};
const borderStyleEnums = [
	"none",
	"hidden",
	"dotted",
	"dashed",
	"solid",
	"double",
	"groove",
	"ridge",
	"inset",
	"outset"
];
const borderTopLeftRadius = {
	xs: "Ws4Oh",
	sm: "iXisq",
	md: "-uNLL",
	lg: "-xbdp",
	xl: "tUF0c",
	clear: "eDgRB"
};
const borderTopRightRadius = {
	xs: "orHbO",
	sm: "cu5p5",
	md: "zjWsb",
	lg: "AhzRR",
	xl: "gXA9X",
	clear: "KsDrt"
};
const borderTopStyle = {
	none: "NlGIx",
	hidden: "pUIaG",
	dotted: "_--FWR",
	dashed: "OvKdZ",
	solid: "yQCsS",
	double: "L5LgN",
	groove: "SM2Rs",
	ridge: "iwE6z",
	inset: "NTJdI",
	outset: "_6bDvZ"
};
const borderTopWidth = {
	thin: "yEWFZ",
	thick: "cTIYq",
	clear: "_1wS6A"
};
const borderWidth = {
	thin: "_6oxdb",
	thick: "LAs7n",
	clear: "Gx-WG"
};
const borderWidthEnums = [
	"thin",
	"thick",
	"clear"
];
const display = {
	none: "U7T-n",
	block: "UiCbf",
	inline: "f29qO",
	"inline-block": "yBWSl",
	"inline-flex": "k8wAL",
	flex: "pw-mp"
};
const displayEnums = [
	"none",
	"block",
	"inline",
	"inline-block",
	"inline-flex",
	"flex"
];
const flex = {
	"1": "fk6ad",
	initial: "AnUEj",
	auto: "q5OPk",
	none: "MAq8F"
};
const flexBasis = {
	"0": "CRY4e",
	auto: "HbLNZ"
};
const flexBasisEnums = [
	"0",
	"auto"
];
const flexDirection = {
	row: "P4JXy",
	"row-reverse": "Rwkdv",
	column: "aupbu",
	"column-reverse": "FdCC9"
};
const flexDirectionEnums = [
	"row",
	"row-reverse",
	"column",
	"column-reverse"
];
const flexEnums = [
	"initial",
	"auto",
	"none",
	"1"
];
const flexGrow = {
	"0": "EUBh3",
	"1": "idXtt",
	"2": "a77te",
	"3": "eq1HI"
};
const flexGrowShrinkEnums = [
	"0",
	"1",
	"2",
	"3"
];
const flexShrink = {
	"0": "D4h9w",
	"1": "O8sGp",
	"2": "y-32D",
	"3": "Tz3bX"
};
const flexWrap = {
	nowrap: "eJexh",
	wrap: "yJFt6",
	"wrap-reverse": "lFOVT"
};
const flexWrapEnums = [
	"nowrap",
	"wrap",
	"wrap-reverse"
];
const justifyContent = {
	center: "eUTyr",
	"space-between": "_06Zt2",
	"space-around": "nf0Km",
	"space-evenly": "tdq3v",
	"flex-end": "-HCks",
	"flex-start": "TmRDD"
};
const justifyContentEnums = [
	"center",
	"space-between",
	"space-around",
	"space-evenly",
	"flex-end",
	"flex-start"
];
const margin = {
	xxTiny: "CfL3G",
	xTiny: "OK3YB",
	tiny: "P-xC8",
	xs: "VlSQN",
	sm: "KC-H5",
	md: "eetEI",
	lg: "d3esU",
	xl: "O73S4",
	xxl: "-yxfy",
	clear: "lBtpQ"
};
const marginLeft = {
	xxTiny: "_1W9NX",
	xTiny: "umtj1",
	tiny: "_7hUDn",
	xs: "QNpf1",
	sm: "wlwuH",
	md: "a9V-G",
	lg: "F4rns",
	xl: "y6GMa",
	xxl: "mFBw3",
	clear: "GGCg9"
};
const marginRight = {
	xxTiny: "LHlY8",
	xTiny: "tO0qa",
	tiny: "YGXrk",
	xs: "Rli-K",
	sm: "dEui9",
	md: "-KgOc",
	lg: "_5uzGs",
	xl: "Q-WoI",
	xxl: "_8U2HC",
	clear: "hpnEH"
};
const marginTop = {
	xxTiny: "pvVSv",
	xTiny: "jH5og",
	tiny: "ZTPF7",
	xs: "DXqLQ",
	sm: "_5Tgrd",
	md: "Lk7U8",
	lg: "LI2Ft",
	xl: "ofRrj",
	xxl: "CkKTU",
	clear: "ArYiB"
};
const opacity = {
	xxs: "_3NV-n",
	xs: "EvsI6",
	sm: "p2YPc",
	md: "A9yPG",
	lg: "s8kCW",
	xl: "qSpwZ",
	xxl: "rCLaz",
	clear: "MiljE"
};
const opacityEnums = [
	"xxs",
	"xs",
	"sm",
	"md",
	"lg",
	"xl",
	"xxl",
	"clear"
];
const order = {
	"0": "bUnIg",
	"1": "_9p7E4",
	"2": "m42cv",
	"3": "I4hmN"
};
const orderEnums = [
	"0",
	"1",
	"2",
	"3"
];
const overflow = {
	visible: "oDJ85",
	hidden: "yMQ4M",
	scroll: "PKhgt",
	auto: "poEhs"
};
const overflowEnums = [
	"visible",
	"hidden",
	"scroll",
	"auto"
];
const overflowX = {
	visible: "vY5s6",
	hidden: "_3uFAy",
	scroll: "tKIXc",
	auto: "_0fkG1"
};
const overflowY = {
	visible: "FJ-hC",
	hidden: "Ip45u",
	scroll: "jIpqu",
	auto: "TixQj"
};
const padding = {
	xxTiny: "toyuH",
	xTiny: "_14BLM",
	tiny: "QilmX",
	xs: "Lap0s",
	sm: "XN-4C",
	md: "Wqozu",
	lg: "g9V6E",
	xl: "_8hT-7",
	xxl: "jDlGC",
	clear: "qs-L5"
};
const paddingBottom = {
	xxTiny: "_7aeI0",
	xTiny: "_46UYo",
	tiny: "q21jZ",
	xs: "_434XL",
	sm: "iftay",
	md: "fubw1",
	lg: "tJknO",
	xl: "roacU",
	xxl: "EUWIj",
	clear: "EjxvN"
};
const paddingLeft = {
	xxTiny: "sSYQP",
	xTiny: "NFRYc",
	tiny: "S95MB",
	xs: "FOZ98",
	sm: "DNSlk",
	md: "Q9K1v",
	lg: "KDMly",
	xl: "MhUB2",
	xxl: "_2Pnkf",
	clear: "_9JPa2"
};
const paddingRight = {
	xxTiny: "r-JBh",
	xTiny: "V9DGr",
	tiny: "No-0m",
	xs: "mQKu-",
	sm: "Ze-N8",
	md: "M8CE9",
	lg: "N34Ko",
	xl: "CXgNY",
	xxl: "zi2wB",
	clear: "O-MJZ"
};
const paddingTop = {
	xxTiny: "Bsx-a",
	xTiny: "jqVt3",
	tiny: "AraDO",
	xs: "ScvIJ",
	sm: "fzfBG",
	md: "FcIgz",
	lg: "RCjbH",
	xl: "wxWoi",
	xxl: "imWfV",
	clear: "Ehs6P"
};
const position = {
	"static": "nOM5f",
	relative: "S2Vce",
	absolute: "-IFej",
	sticky: "_7olkW",
	fixed: "hMwMM"
};
const positionEnums = [
	"static",
	"relative",
	"absolute",
	"sticky",
	"fixed"
];
const textAlign = {
	left: "rb-UF",
	right: "WvsYz",
	center: "Eo0rJ",
	justify: "VMysR"
};
const textAlignEnums = [
	"left",
	"right",
	"center",
	"justify"
];
const verticalAlign = {
	baseline: "iPYkv",
	top: "ing7-",
	middle: "T-fDW",
	bottom: "_2jeWb",
	sub: "lltMC",
	"text-top": "IHNtx"
};
const verticalAlignEnums = [
	"baseline",
	"top",
	"middle",
	"bottom",
	"sub",
	"text-top"
];

exports.alignContent = alignContent;
exports.alignContentEnums = alignContentEnums;
exports.alignItems = alignItems;
exports.alignItemsEnums = alignItemsEnums;
exports.alignSelf = alignSelf;
exports.alignSelfEnums = alignSelfEnums;
exports.borderBottomLeftRadius = borderBottomLeftRadius;
exports.borderBottomRightRadius = borderBottomRightRadius;
exports.borderBottomStyle = borderBottomStyle;
exports.borderBottomWidth = borderBottomWidth;
exports.borderLeftStyle = borderLeftStyle;
exports.borderLeftWidth = borderLeftWidth;
exports.borderRightStyle = borderRightStyle;
exports.borderRightWidth = borderRightWidth;
exports.borderStyle = borderStyle;
exports.borderStyleEnums = borderStyleEnums;
exports.borderTopLeftRadius = borderTopLeftRadius;
exports.borderTopRightRadius = borderTopRightRadius;
exports.borderTopStyle = borderTopStyle;
exports.borderTopWidth = borderTopWidth;
exports.borderWidth = borderWidth;
exports.borderWidthEnums = borderWidthEnums;
exports.display = display;
exports.displayEnums = displayEnums;
exports.flex = flex;
exports.flexBasis = flexBasis;
exports.flexBasisEnums = flexBasisEnums;
exports.flexDirection = flexDirection;
exports.flexDirectionEnums = flexDirectionEnums;
exports.flexEnums = flexEnums;
exports.flexGrow = flexGrow;
exports.flexGrowShrinkEnums = flexGrowShrinkEnums;
exports.flexShrink = flexShrink;
exports.flexWrap = flexWrap;
exports.flexWrapEnums = flexWrapEnums;
exports.justifyContent = justifyContent;
exports.justifyContentEnums = justifyContentEnums;
exports.margin = margin;
exports.marginLeft = marginLeft;
exports.marginRight = marginRight;
exports.marginTop = marginTop;
exports.opacity = opacity;
exports.opacityEnums = opacityEnums;
exports.order = order;
exports.orderEnums = orderEnums;
exports.overflow = overflow;
exports.overflowEnums = overflowEnums;
exports.overflowX = overflowX;
exports.overflowY = overflowY;
exports.padding = padding;
exports.paddingBottom = paddingBottom;
exports.paddingLeft = paddingLeft;
exports.paddingRight = paddingRight;
exports.paddingTop = paddingTop;
exports.position = position;
exports.positionEnums = positionEnums;
exports.textAlign = textAlign;
exports.textAlignEnums = textAlignEnums;
exports.verticalAlign = verticalAlign;
exports.verticalAlignEnums = verticalAlignEnums;
